import { useEffect, useState } from "react";
// react redux
import { useSelector, useDispatch } from "react-redux";
// hooks
import usePageParams from "../../hooks/usePageParams";
// axios
import EnhancedAxios from "../../axios/EnhancedAxios";
import { AxiosResponse, AxiosError } from "axios";
// mui
import { Stack, Box, Button } from "@mui/material";
// components
import {
    PageTitle,
    SortBox,
    SearchBox,
    TableGrid,
    LinkButton,
    ThreeDotsLoader,
    IsConfirmedFilterBox,
    AppFilter,
} from "../../components";
// cols
import { transactionsCols } from "../../utils/gridCols/transactionsCols";
import { errorAlert } from "../../utils/alerts/alerts";
import { ReduxUserReducerState } from "../../types/global";
import DownloadCSV from "../../components/modal/DownloadCsv";

const Transactions = () => {
    const userToken = useSelector(
        (state: ReduxUserReducerState) => state.user.userToken
    );
    const open = useSelector((state: any) => state.notify.open);
    const { page, setPage } = usePageParams();
    const [transactions, setTransactions] = useState([]);
    const [sortValue, setSortValue] = useState<string>("-created_at");
    const [app, setApp] = useState("all");
    const [searchValue, setSearchValue] = useState("");
    const [itemsPerPage, setItemsPerPage] = useState(24);
    const [totalItems, setTotalItems] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [filterValues, setFilterValues] = useState({
        isConfirmed: "is_confirmed:eq:true",
    });
    // get all users
    useEffect(() => {
        setLoading(true);
        let endpoint = `/admin/wallet-transactions?page=${page}&paginate=${itemsPerPage}&sorts=${sortValue}&q=${searchValue}&filters=${filterValues.isConfirmed}`;
        if (app && app != "all") endpoint += `,category_id:${app}`;
        EnhancedAxios(null, userToken)
            .get(endpoint)
            .then((res: AxiosResponse) => {
                setTransactions(res.data.data);
                setTotalItems(res.data.meta.total);
                setLoading(false);
            })
            .catch((error: AxiosError) => {
                errorAlert(error);
            });
    }, [page, sortValue, searchValue, filterValues, app]);
    return (
        <Stack gap="20px">
            <PageTitle title="سجل عمليات الدفع" />
            <DownloadCSV
                endpoint="/admin/wallet-transactions/report"
                title="عمليات التحويل"
                downloadedFilename="report=transactions"
            />
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap="10px"
                flexWrap="wrap"
            >
                <SearchBox
                    searchValue={searchValue}
                    setSearchValue={setSearchValue}
                />
                <SortBox sortValue={sortValue} setSortValue={setSortValue} />
                <IsConfirmedFilterBox
                    filterValues={filterValues}
                    setFilterValues={setFilterValues}
                />
                <AppFilter value={app} setValue={setApp} />
            </Box>
            {loading ? (
                <ThreeDotsLoader />
            ) : transactions.length === 0 ? (
                <p className="center-text">لا يوجد عمليات شحن سابقة </p>
            ) : (
                <TableGrid
                    rows={transactions}
                    cols={transactionsCols}
                    itemsPerPage={itemsPerPage}
                    totalItems={totalItems}
                    currentPage={page}
                    setCurrentPage={setPage}
                />
            )}
        </Stack>
    );
};

export default Transactions;
